var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Translate } from "../../../../../I18N";

import { Button } from "../../../../Components/UI";
import { importThesaurus } from "../../../../api/thesauri";

const ImportButton = ({
  onSuccess,
  onFailure,
  getThesaurus,
  onClick,
  disabled






}) => {
  const importThesauri = async (e) => {
    if (e.target.files && e.target.files[0]) {
      try {
        const thesaurus = getThesaurus();
        const data = await importThesaurus(thesaurus, e.target.files[0]);
        onSuccess(data);
      } catch (ex) {
        onFailure(ex);
      }
    } else {
      onFailure();
    }
    document.querySelector('input#import').setAttribute('value', '');
  };
  return (/*#__PURE__*/
    _jsx(Button, {
      disabled: disabled === true,
      styling: "outline",
      "data-testid": "thesaurus-import-items",
      onClick: (e) => {
        onClick(e);
        document.querySelector('input#import').click();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Import"), /*#__PURE__*/
    _jsx("input", { type: "file", id: "import", hidden: true, onChange: importThesauri })
    ));

};

export { ImportButton };